Object.defineProperty(exports,"__esModule",{value:true});var _omit2=require("lodash/omit");var _omit3=_interopRequireDefault(_omit2);var _defaults2=require("lodash/defaults");var _defaults3=_interopRequireDefault(_defaults2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=require("react");var _react2=_interopRequireDefault(_react);
var _index=require("../victory-util/index");function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var


VictoryPortal=function(_React$Component){_inherits(VictoryPortal,_React$Component);function VictoryPortal(){_classCallCheck(this,VictoryPortal);return _possibleConstructorReturn(this,(VictoryPortal.__proto__||Object.getPrototypeOf(VictoryPortal)).apply(this,arguments));}_createClass(VictoryPortal,[{key:"componentDidMount",value:function componentDidMount()










{
if(!this.checkedContext){
if(typeof this.context.portalUpdate!=="function"){
var msg="`renderInPortal` is not supported outside of `VictoryContainer`. "+
"Component will be rendered in place";
_index.Log.warn(msg);
this.renderInPlace=true;
}
this.checkedContext=true;
}
this.forceUpdate();
}},{key:"componentDidUpdate",value:function componentDidUpdate()

{
if(!this.renderInPlace){
this.portalKey=this.portalKey||this.context.portalRegister();
this.context.portalUpdate(this.portalKey,this.element);
}
}},{key:"componentWillUnmount",value:function componentWillUnmount()

{
if(this.context&&this.context.portalDeregister){
this.context.portalDeregister(this.portalKey);
}
}},{key:"renderPortal",value:function renderPortal(


child){
if(this.renderInPlace){
return child;
}
this.element=child;
return null;
}},{key:"render",value:function render()

{var
children=this.props.children;
var childProps=children&&children.props||{};
var child=children&&_react2.default.cloneElement(
children,(0,_defaults3.default)({},childProps,(0,_omit3.default)(this.props,"children")));

return this.renderPortal(child);
}}]);return VictoryPortal;}(_react2.default.Component);VictoryPortal.propTypes={children:_react2.default.PropTypes.node};VictoryPortal.contextTypes={portalUpdate:_react2.default.PropTypes.func,portalRegister:_react2.default.PropTypes.func,portalDeregister:_react2.default.PropTypes.func};exports.default=VictoryPortal;


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-portal/victory-portal.js
// module id = 621
// module chunks = 0